import React, { Component } from "react";
import PropTypes from "prop-types";
import Header from "../components/Header.js";
import icon_error from "../images/icone-error-document.svg";
import { Camera } from "../components/camera";
import RegistrationAnalysis from "../containers/RegistrationAnalysis";
import api from "../containers/api";
import ErrorGeneric from "../containers/ErrorGeneric";
import gif_documento from "../images/gif-vire-documento.gif";
import gif_documento_plastico from "../images/gif-id-plastico.gif";
import { ConfiaCapture } from "../components/confiaCaptures/ConfiaCapture.js";
export class Capture extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderAlert: true,
      renderFrontCapture: false,
      renderFrontSuccess: false,
      renderBackCapture: false,
      renderCaptureError: false,
      renderDataError: false,
      base64Front: null,
      base64Back: null,
      stepError: null,
      renderOtherDocuments: false,
      type: null,
    };
  }
  handleClickPassport(documentType) {
    this.setState({
      renderFrontCapture: true,
      renderCaptureError: false,
      renderAlert: false,
      renderOtherDocuments: false,
      type: documentType,
    });
    this.props.funStartInterval(1, 5000);
  }

  handleClickContinuar(documentType) {
    this.setState({
      renderFrontCapture: true,
      renderCaptureError: false,
      renderAlert: false,
      renderOtherDocuments: false,
      type: documentType,
    });
    // this.props.funStartInterval(1, 5000);
  }

  handleClickOtherDocuments() {
    this.setState({
      renderOtherDocuments: true,
      renderFrontCapture: false,
      //passport: false,
      renderCaptureError: false,
      renderAlert: false,
      type: null,
    });
  }

  handleClickError = () => {
    if (this.state.stepError == 1) {
      this.setState({
        renderFrontCapture: true,
        renderCaptureError: false,
        stepError: null,
      });
      this.props.funStartInterval(1, 5000);
    } else if (this.state.stepError == 2) {
      this.setState({
        renderBackCapture: true,
        renderCaptureError: false,
        stepError: null,
      });
      this.props.funStartInterval(2, 5000);
    }
  };

  async handleCaptureFront(blob) {
    window.ConfiaAudioFront.stopFront();
    this.props.funClearInterval();
    this.setState({
      base64Front: await this.blobToBase64(blob),
      renderFrontCapture: false,
    });

    var requestRollbar = {
      apiPost: `/checkDocumentImage/${this.props.identifier}`,
      image: this.state.base64Front,
      isFront: true,
      transactionUuid: this.props.transactionUuid,
    };
    this.props.funRollbar(requestRollbar);

    api
      .post(`/checkDocumentImage/${this.props.identifier}`, {
        image: this.state.base64Front,
        isFront: true,
        transactionUuid: this.props.transactionUuid,
      })
      .then((response) => {
        this.props.funRollbar(response);

        if (response.data.code == 0) {
          if (this.state.type == "PASSAPORTE") {
            return this.identificationCheck();
          }
          this.setState({ renderFrontSuccess: true });
        } else {
          this.setState({ renderCaptureError: true, stepError: 1 });
        }
      })
      .catch((error) => {
        this.props.onError(error);
      });
  }

  handleClickNext() {
    this.setState({ renderBackCapture: true, time: 4000 });
    this.props.funStartInterval(2, 5000);
  }

  async handleCaptureBack(blob) {
    window.ConfiaAudioBack.stopBack();
    this.props.funClearInterval();
    this.setState({
      base64Back: await this.blobToBase64(blob),
      renderBackCapture: false,
      renderFrontSuccess: false,
    });

    var requestRollbar = {
      apiPost: `/checkDocumentImage/${this.props.identifier}`,
      image: this.state.base64Back,
      transactionUuid: this.props.transactionUuid,
    };
    this.props.funRollbar(requestRollbar);

    api
      .post(`/checkDocumentImage/${this.props.identifier}`, {
        image: this.state.base64Back,
        transactionUuid: this.props.transactionUuid,
      })
      .then((response) => {
        this.props.funRollbar(response);
        if (response.data.code == 0) {
          this.identificationCheck(true);
        } else {
          this.setState({ renderCaptureError: true, stepError: 2 });
        }
      })
      .catch((error) => {
        this.props.onError(error);
      });
  }

  identificationCheck = (captureBackOk) => {
    let processar = false;
    if (this.state.type == "PASSAPORTE") {
      var requestRollbar = {
        apiPost: `/abis/identificationCheck/${this.props.identifier}`,
        idFrontImage: this.state.base64Front,
        selfie: this.props.imagesAuditTrail[0],
        externalDatabaseRefID: this.props.externalDatabaseRefID,
        type: this.state.type,
        transactionUuid: this.props.transactionUuid,
      };
      processar = true;
    } else if (captureBackOk) {
      var requestRollbar = {
        apiPost: `/abis/identificationCheck/${this.props.identifier}`,
        idFrontImage: this.state.base64Front,
        idBackImage: this.state.base64Back,
        selfie: this.props.imagesAuditTrail[0],
        externalDatabaseRefID: this.props.externalDatabaseRefID,
        type: this.state.type,
        transactionUuid: this.props.transactionUuid,
      };
      processar = true;
    }

    if (processar) {
      this.props.funRollbar(requestRollbar);

      api
        .post(`${requestRollbar.apiPost}`, requestRollbar)
        .then((response) => {
          this.props.funRollbar(response);
          if (response.data.code == 97) {
            this.setState({ renderDataError: true });
          } else {
            this.props.onSuccess(response.data.authToken, response.data.docIds);
          }
        })
        .catch((error) => {
          this.props.onError(error);
        });
    }
  };

  blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.substring(reader.result.indexOf(",") + 1));
      reader.readAsDataURL(blob);
    });
  }

  render() {
    if (this.state.renderOtherDocuments) {
      return (
        <div className="container h-100" style={{ overflowY: "hidden" }}>
          <Header logo={this.props.logo} />
          <div className="row" style={{ minHeight: "calc(100vh - 100px)" }}>
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 ">
              <div className="card h-100">
                <div className="text-center px-4 mt-5">
                  <h4 className="card-title fw-bold text-secondary">ESCOLHA O TIPO DE DOCUMENTO</h4>
                </div>
                <img src={gif_documento_plastico} style={{ height: "130px" }} className="img-fluid mx-auto d-block" alt="" />
                <div className="card-body text-center px-4">
                  <div className="row justify-content-center">
                    <div className="col-8 d-grid">
                      <button className="btn btn-primary fw-bold mt-3" type="button" onClick={() => this.handleClickContinuar("RG")}>
                        RG
                      </button>
                      <button className="btn btn-primary fw-bold mt-3" type="button" onClick={() => this.handleClickContinuar("CNH")}>
                        CNH
                      </button>
                      <button className="btn btn-primary fw-bold mt-3" type="button" onClick={() => this.handleClickPassport("PASSAPORTE")}>
                        PASSAPORTE
                      </button>
                      <button className="btn btn-primary fw-bold mt-3" type="button" onClick={() => this.handleClickContinuar("MILITAR")}>
                        DOCUMENTO DE MILITARES
                      </button>
                      <button className="btn btn-primary fw-bold mt-3" type="button" onClick={() => this.handleClickContinuar("RNE")}>
                        RNE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.renderFrontCapture) {
      return (
        <div className="container h-100">
          <div className="row justify-content-center mt-5" style={{ display: "grid" }}>
            <ul style={{ listStyleType: "none" }}>
              <li>
                <div
                  className="row justify-content-center mt-5"
                  style={{
                    display: "grid",
                    borderRadius: "10px",
                    backgroundColor: "white",
                    paddingBottom: "5%",
                    paddingTop: "5%",
                  }}
                >
                  <h5 className="card-text text-secondary">1. MOSTRE O LADO COM FOTO</h5>
                </div>
              </li>
            </ul>
          </div>
          <ConfiaCapture onCapture={(blob) => this.handleCaptureFront(blob)} />
        </div>
      );
    } else if (this.state.renderBackCapture) {
      return (
        <div className="container h-100">
          <div className="row justify-content-center mt-5" style={{ display: "grid" }}>
            <ul style={{ listStyleType: "none" }}>
              <li>
                <div
                  className="row justify-content-center mt-5"
                  style={{
                    display: "grid",
                    borderRadius: "10px",
                    backgroundColor: "white",
                    paddingBottom: "5%",
                    paddingTop: "5%",
                  }}
                >
                  <h5 className="card-text text-secondary">2. MOSTRE O LADO SEM FOTO</h5>
                </div>
              </li>
            </ul>
          </div>
          <ConfiaCapture onCapture={(blob) => this.handleCaptureBack(blob)} />
        </div>
      );
    } else if (this.state.renderCaptureError) {
      return (
        <div className="container h-100">
          <div className="row text-center px-4 mt-5" style={{ minHeight: "calc(100vh - 106px)" }}>
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5">
              <img src={icon_error} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-5" />
              <h1 className="card-title fw-bold text-white mt-5">NÃO DEU CERTO</h1>
              <h5 className="card-text text-light mt-5">Precisamos de uma foto melhor.</h5>
              <div className="row mt-5 justify-content-center">
                <div className="col-6 d-grid mt-5">
                  <a href={this.props.helperURL} target="_blank" className="btn btn-secondary w-100 fw-bold">
                    PRECISO DE AJUDA
                  </a>
                </div>
                <div className="col-6 d-grid mt-5">
                  <button className="btn btn-primary fw-bold" type="button" onClick={() => this.handleClickError()}>
                    TENTAR DE NOVO
                  </button>
                </div>
                <div className="col-12">
                  <button className="btn btn-secondary fw-bold mt-3" type="button" onClick={() => this.handleClickOtherDocuments()}>
                    INFORMAR OUTRO TIPO DE DOCUMENTO
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.renderAlert) {
      return (
        <div className="container">
          <Header logo={this.props.logo} />
          <div className="row" style={{ minHeight: "calc(100vh - 100px)" }}>
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2">
              <div className="card h-100" style={{ position: "relative" }}>
                <div className="text-center px-4 mt-3">
                  <h4 className="card-title fw-bold text-secondary">VAMOS AGORA TIRAR A FOTO DA IDENTIDADE</h4>
                </div>
                <img src={gif_documento_plastico} style={{ height: "130px" }} className="img-fluid mx-auto d-block" alt="" />
                <div className="card-body text-center px-4 mb-5" style={{ overflowY: "auto", maxHeight: "calc(100vh - 240px)", paddingBottom: "120px" }}>
                  <h5 className="card-text text-secondary mt-2 mb-5">Clique em continuar para fotografar um lado de cada vez, na horizontal.</h5>
                </div>
                <div className="fixed-button-container">
                  <div className="row justify-content-center">
                    <div className="col-8 d-grid">
                      <button className="btn btn-primary fw-bold" type="button" onClick={() => this.handleClickContinuar("RG")}>
                        CAPTURAR RG
                      </button>
                      <button className="btn btn-secondary fw-bold mt-3" type="button" onClick={() => this.handleClickOtherDocuments()}>
                        INFORMAR OUTRO TIPO DE DOCUMENTO
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.renderFrontSuccess) {
      return (
        <div className="container h-100" style={{ overflowY: "hidden" }}>
          <div className="row text-center px-4 mt-5" style={{ minHeight: "calc(100vh - 106px)" }}>
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5">
              <h1 className="card-title fw-bold text-white mt-5">DEU CERTO!</h1>
              <h1 className="card-title fw-bold text-white">AGORA O OUTRO LADO</h1>
              <img src={gif_documento} style={{ maxHeight: "150px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
              <div className="row mt-5 justify-content-center">
                <div className="col-6 d-grid mt-5">
                  <button className="btn btn-primary fw-bold" type="button" onClick={() => this.handleClickNext()}>
                    CONTINUAR
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.renderDataError) {
      return <ErrorGeneric dataInvalid={true} />;
    } else {
      return <RegistrationAnalysis />;
    }
  }
}

Capture.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  identifier: PropTypes.string.isRequired,
  imagesAuditTrail: PropTypes.object.isRequired,
  funStartInterval: PropTypes.func.isRequired,
  funClearInterval: PropTypes.func.isRequired,
  funRollbar: PropTypes.func.isRequired,
  externalDatabaseRefID: PropTypes.string.isRequired,
  transactionUuid: PropTypes.string.isRequired,
};

export default Capture;
